import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import ErrorMessage from "../../components/ErrorMessage";
import {BrowserRouter as Router, Redirect} from "react-router-dom";
import {Form, FormCheck, Col, InputGroup, Button, ButtonGroup} from "react-bootstrap";
import {config} from "../../components/Constants";

class ToolsChangeServicePasswd extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      submitError: null,
      isLoaded: true,
      isLoggedIn: false,
      isSubmitting: false,
      redirect: null,
      servicePasswordTemplate: null
    };
    this.handleSubmitForm = this.handleSubmitForm.bind(this);
    this.handleReturn = this.handleReturn.bind(this);
  }

  componentDidMount() {
    fetch(config.API_URL + '/api/tools/servicePasswd', {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(
        (result) => {
          if (result.error) {
            this.setState({
              servicePasswordTemplate: null,
              isLoaded: true,
              error: result.error
            });
          } else if (result) {
            this.setState({
              servicePasswordTemplate: result.servicePasswordTemplate,
              isLoaded: true
            });
          }
        },
        (error) => {
          this.setState({
            servicePasswordTemplate: null,
            isLoaded: true,
            error: error
          });
        }
      );
  }

  handleSubmitForm(event) {
  }

  handleReturn(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    this.setState({
      redirect: '/tools'
    });
    return false;
  }

  render() {
    const {error, isLoaded, isLoggedIn, isSubmitting, submitError, redirect, servicePasswordTemplate} = this.state;
    const that = this;
    if (!isLoaded) {
      return (
        <LoadingSpin/>
      );
    } else if (redirect !== null) {
      return <Redirect to={redirect}/>
    } else if (error) {
      return (
        <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
          {'title': 'Powrót', 'callback': function() {that.setState({redirect: '/clients', error: null});}}
        ]} handleClose={() => {that.setState({redirect: '/clients', error: null});}}/>
      );
    } else {
      return (
        <React.Fragment>
          {isSubmitting ? <LoadingSpin/> : ''}
          <header className="clients-header">
            <h1>Zmiana hasła kont serwisowych</h1>
          </header>
        </React.Fragment>
      );
    }
  }

}

export default ToolsChangeServicePasswd;
